import { IOption } from "Dashboard/domain/IOption";
import { incidentsService } from "Dashboard/scenes/Incidents/services/incidents.service";
import { useEffect, useState } from "react";

export function useIncidentTypeOptions() {
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    async function getIncidentTypes() {
      console.log('Should call api only once')
      const data = await incidentsService.getAllIncidentTypes();
      const op = data.map((incident) => {
        return {
          label: incident.name,
          value: incident.incidentTypeId,
        };
      });
      setOptions(op);
      console.log(options);
    }

    try {
      getIncidentTypes();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return { incidentTypeOptions: options, setIncidentTypeOptions: setOptions };
}
